// Звёзды рейтинга поставщика 1–5. Read-only в таблице (size sm),
// кликабельные в карточке (onChange задан): клик по текущему значению
// снимает оценку (rating=null).
export function RatingStars({
  value,
  onChange,
  size = 'sm',
}: {
  value: number | null
  onChange?: (next: number | null) => void
  size?: 'sm' | 'lg'
}) {
  const cls = size === 'lg' ? 'text-xl' : 'text-sm'
  return (
    <span className={`inline-flex items-center gap-0.5 ${cls} leading-none`}>
      {[1, 2, 3, 4, 5].map((n) => {
        const filled = value != null && n <= value
        const star = (
          <span className={filled ? 'text-amber-400' : 'text-gray-300'}>{filled ? '★' : '☆'}</span>
        )
        if (!onChange) return <span key={n}>{star}</span>
        return (
          <button
            key={n}
            type="button"
            onClick={() => onChange(value === n ? null : n)}
            title={value === n ? 'Снять оценку' : `Оценка ${n} из 5`}
            className="hover:scale-110 transition-transform"
          >
            {star}
          </button>
        )
      })}
    </span>
  )
}
